import { render } from "./RememberToOrder.vue?vue&type=template&id=16a15fa8&ts=true"
import script from "./RememberToOrder.vue?vue&type=script&lang=ts"
export * from "./RememberToOrder.vue?vue&type=script&lang=ts"

import "./RememberToOrder.vue?vue&type=style&index=0&id=16a15fa8&lang=scss"

import exportComponent from "/home/issa/hcpet/hcpet-kasse/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__